/**
 * @file: Operation.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂运营
 */
import request from '@/utils/request'

/**
 * 食堂运营-周收益成本（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function operationWeekGet(data) {
  return request({
    type: 'biz',
    url: 'operation/week/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Operation.js